module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "integralMallExchangeDetails paddingTop45"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue"
  }, [_vm._v("礼品卡兑换记录")]), _vm._v(" "), _vm._l((_vm.shopList), function(item, index) {
    return _c('form-preview', {
      key: index,
      attrs: {
        "header-label": "商品名称",
        "header-value": item.GOODSNAME,
        "footer-buttons": item.bottonclick,
        "name": index,
        "body-items": item.list
      }
    })
  }), _vm._v(" "), _c('divider', [_vm._v("没有啦")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-310535c8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/integralMallProject/integralMallExchangeDetails.vue
// module id = Y+zW
// module chunks = 6